<script setup lang="ts">
import { ArrowRight, Filter, FolderKanban, Plus, Search } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useProjectStore } from '@/stores/domain'

const { projects } = storeToRefs(useProjectStore())
</script>

<template>
  <div class="section-page">
    <header class="section-page__header">
      <div>
        <span class="eyebrow">Portfolio</span>
        <h1>Projects</h1>
        <p>Outcomes your Manager is turning into operating systems.</p>
      </div>
      <RouterLink class="button button--dark" to="/app/manager">
        <Plus :size="16" /> New through Manager
      </RouterLink>
    </header>
    <div class="section-toolbar">
      <label><Search :size="16" /><input type="search" placeholder="Search projects" /></label>
      <button class="soft-button" type="button"><Filter :size="15" /> Filter</button>
    </div>
    <div class="project-grid">
      <RouterLink
        v-for="project in projects"
        :key="project.id"
        class="project-card"
        :to="`/app/projects/${project.id}`"
      >
        <div class="project-card__top">
          <span class="project-icon"><FolderKanban :size="18" /></span>
          <span class="status-pill" :class="`status-pill--${project.health}`"
            ><i></i>{{ project.status.replace('_', ' ') }}</span
          >
        </div>
        <h2>{{ project.name }}</h2>
        <p>{{ project.description }}</p>
        <div class="project-card__objective">
          <span>OBJECTIVE</span><strong>{{ project.objective }}</strong>
        </div>
        <div class="project-card__progress">
          <div>
            <span>Progress</span><strong>{{ project.progressPercent }}%</strong>
          </div>
          <div class="progress-track">
            <span :style="{ width: `${project.progressPercent}%` }"></span>
          </div>
        </div>
        <div class="project-card__footer">
          <span>Updated recently</span><strong>Open project <ArrowRight :size="14" /></strong>
        </div>
      </RouterLink>
    </div>
    <div v-if="!projects.length" class="detail-card">
      <h2>No projects yet</h2>
      <p>Ask your Manager to create the first project and define its objective.</p>
    </div>
  </div>
</template>
